var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 598 415",
    height: "100%",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_505)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M448.44 182.82L373.74 225.95L299.04 182.82L373.74 139.69L448.44 182.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M373.74 225.95L448.44 182.82L523.14 225.95L448.44 269.08L373.74 225.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M373.74 225.95L448.44 269.08L373.74 333.32L299.04 290.19L373.74 225.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M523.14 225.95L448.44 182.82L523.14 139.69L597.84 182.82L523.14 225.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M448.44 182.82L373.74 139.69L448.44 96.5601L523.14 139.69L448.44 182.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M448.44 96.5701L373.74 139.7L299.04 86.6901L373.74 43.5601L448.44 96.5701Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M373.74 225.95L299.04 290.19L224.34 247.06L299.04 182.82L373.74 225.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M299.04 290.19L373.74 333.32L299.04 376.45L224.34 333.32L299.04 290.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M149.65 96.5701L224.35 43.5601L299.05 86.6901L224.35 139.7L149.65 96.5701V96.5701Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M149.65 96.5701L224.35 139.7L149.65 203.94L74.95 160.81L149.65 96.5701V96.5701Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M224.34 139.7L299.04 86.6899V182.83L224.34 139.7V139.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M299.04 86.6899L224.34 43.5599L299.04 0.429932L373.74 43.5599L299.04 86.6899Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M224.34 139.7L299.04 182.83L224.34 247.07L149.64 203.94L224.34 139.7V139.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M373.74 139.7L299.04 182.83V86.6899L373.74 139.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M149.65 203.94L224.35 247.07L149.65 290.2L74.95 247.07L149.65 203.94V203.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M74.95 160.81L149.65 203.94L74.95 247.07L0.25 203.94L74.95 160.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M299.04 290.19L224.34 333.32L149.64 290.19L224.34 247.06L299.04 290.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M448.44 182.82L373.74 225.95M448.44 269.08L373.74 225.95"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M523.14 225.95L448.44 269.08"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M523.14 225.95L448.44 182.82M448.44 96.5701L373.74 139.7M448.44 182.83L373.74 139.7M523.14 139.7L448.44 182.83"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M523.14 139.7L448.44 96.5701M448.44 269.08L373.74 333.32"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M373.74 225.95L299.04 290.19M373.74 333.32L299.04 290.19"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M597.83 182.82L523.13 225.95M597.83 182.82L523.13 139.69M224.34 43.5601L149.64 96.5701"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M224.34 139.7L149.64 96.5701M299.04 86.6901L224.34 139.7M299.04 86.6901L224.34 43.5601M299.04 182.82L224.34 139.69M373.74 139.69L299.04 182.82M373.74 139.69L299.04 86.6801M299.04 182.82L224.34 247.06M224.34 139.69L149.64 203.93M224.34 247.06L149.64 203.93"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M149.65 96.5701L74.95 160.81"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M149.65 203.94L74.95 160.81"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M299.04 0.429932L224.34 43.5599"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M373.74 43.5601L299.04 86.6901"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M373.74 43.5599L299.04 0.429932M373.74 333.32L299.04 376.45"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M299.04 290.19L224.34 333.32"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M299.04 376.45L224.34 333.32"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M149.65 203.94L74.95 247.06"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M74.95 160.81L0.25 203.94M74.95 247.07L0.25 203.94"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M224.34 247.06L149.65 290.19"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M149.65 290.19L74.95 247.06M224.35 333.31L149.65 290.18"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M299.04 290.19L224.34 247.06"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M448.44 96.5701L373.74 43.5601"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M373.74 225.95L299.04 182.82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_505"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 415,
    width: 598
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlope);
export default __webpack_public_path__ + "static/media/slope.fc63f2266a836676b459f56a4280069b.svg";
export { ForwardRef as ReactComponent };